import { apiGet, apiPost } from '@lib/api/client';
import type { BillingCurrent, BillingPackage } from '../types';

export interface BillingInvoice {
  id: string;
  number?: string | null;
  status?: string;
  created: number;
  amount_paid: number;
  amount_due: number;
  currency: string;
  hosted_invoice_url?: string | null;
  invoice_pdf?: string | null;
}

export const billingApi = {
  quote: () => apiGet<{ packages: BillingPackage[] }>('/api/billing/quote'),
  current: () => apiGet<BillingCurrent>('/api/billing/current'),
  createCheckoutSession: (body: { packageId: string }) =>
    apiPost<{ url: string }, typeof body>('/api/billing/create-checkout-session', body),
  createAddonSession: (body: { type: 'employees' | 'devices'; qty: number }) =>
    apiPost<{ url: string }, typeof body>('/api/billing/create-addon-session', body),
  invoices: () => apiGet<{ invoices: BillingInvoice[] }>('/api/billing/invoices'),
  createPortalSession: () =>
    apiPost<{ url: string }>('/api/billing/create-portal-session'),
};
